module.exports = __webpack_public_path__ + "img/jcb.c8f6d92.svg";